import { SearchBar } from "antd-mobile";
import type { SearchBarProps } from "antd-mobile";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { ReactNode } from "react";

interface IProps extends SearchBarProps {
  leftIcon?: ReactNode;
  onChange?: (value: string) => Promise<void>;
  onSearchClick?: () => void;
  headingText?: string;
}

export const WebSearchBar: FC<IProps> = ({
  leftIcon,
  onChange,
  onSearchClick,
  headingText,
}) => {
  return (
    <div className={styles.container} onClick={onSearchClick}>
      <SearchBar
        value=""
        placeholder="Search by Patient Name or Room"
        data-test-id="search"
        clearable
        className={classNames(styles.globalSearchBar, {
          [styles.searchBarWithoutIcon]: !leftIcon,
        })}
        icon={leftIcon}
        onChange={onChange}
      />
      {headingText && (
        <h5 className={styles.heading} id="main-heading">
          {headingText}
        </h5>
      )}
    </div>
  );
};
